import axios from "axios";
import { acceptVideoCallApi, localToken, onGoingVideoCallLogsApi, requestVideoCallApi } from "../../constants/apis/new_hud_apis";

export const getOnGOingCalls = async (packageId) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(onGoingVideoCallLogsApi, config);
    return response;
};

export const startNewMeeting = async (data) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(requestVideoCallApi, data, config);
    return response;
};

export const joinOngoingMeeting = async (id) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(acceptVideoCallApi + id + "/", {}, config);
    return response;
};
